import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SavePhoneNumberMutation = gql`
   mutation SavePhoneNumber($phoneNumber: PhoneNumberInput!) {
      phoneNumber: savePhoneNumber(phoneNumber: $phoneNumber) {
         phoneNumberId
         phoneNumber
         accountId
         locationId
         timeZoneId
         displayName
         openExtensionId
         closedExtensionId
         faxExtensionId
         scheduleId
         providerId
         isPorted
         isActive
         notes
         allowOutboundCalls
         datePorted
      }
   }
`;
